import {
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  REQUEST_LOADING,
  RESET_REQUEST_STATE,
  SET_CARD_INSIGHT_METADATA,
  OPEN_KNOWLEDGE_CENTER,
  CLOSE_KNOWLEDGE_CENTER,
  KNOWLEDGE_CENTER_STATE_KEY,
  OPEN_CONTRACT_ID_EDITOR,
  CLOSE_CONTRACT_ID_EDITOR,
  CONTRACT_ID_SELECTION_APPLIED,
} from '../../actions/actionTypes';
import {
  initialContractIdEditorState,
  ContractIdEditorState,
  OpenContractIdEditorPayload,
  ContractIdSelectionAppliedPayload,
} from '@src/CommonComponents/ContractIdFilter/contractIdEditor.types';

type CommonState = {
  contractIdEditor: ContractIdEditorState;
  [key: string]: unknown;
};

type CommonAction = {
  type: string;
  payload?: unknown;
  key?: string;
};

const initialState: CommonState = {
  contractIdEditor: initialContractIdEditorState,
};

const commonReducer = (state = initialState, action: CommonAction): CommonState => {
  switch (action.type) {
    case OPEN_CONTRACT_ID_EDITOR:
      return {
        ...state,
        contractIdEditor: {
          ...initialContractIdEditorState,
          ...(action.payload as OpenContractIdEditorPayload),
          isOpen: true,
        },
      };
    case CLOSE_CONTRACT_ID_EDITOR:
      return {
        ...state,
        contractIdEditor: initialContractIdEditorState,
      };
    case CONTRACT_ID_SELECTION_APPLIED:
      return {
        ...state,
        contractIdEditor: {
          ...state.contractIdEditor,
          isOpen: false,
          selectedIds: (action.payload as ContractIdSelectionAppliedPayload).selectedContractIds,
        },
      };
    case REQUEST_LOADING:
      if (!action.key) return state;
      return {
        ...state,
        [action.key]: action.payload,
      };
    case REQUEST_FAILURE:
      if (!action.key) return state;
      return {
        ...state,
        [action.key]: action.payload,
      };
    case REQUEST_SUCCESS:
      if (!action.key) return state;
      return {
        ...state,
        [action.key]: action.payload,
      };
    case SET_CARD_INSIGHT_METADATA:
      if (!action.key) return state;
      return {
        ...state,
        [action.key]: action.payload,
      };
    case OPEN_KNOWLEDGE_CENTER:
      return {
        ...state,
        [action?.key || KNOWLEDGE_CENTER_STATE_KEY]: action.payload,
      };
    case CLOSE_KNOWLEDGE_CENTER:
      return {
        ...state,
        [action?.key || KNOWLEDGE_CENTER_STATE_KEY]: action.payload,
      };
    case RESET_REQUEST_STATE: {
      // Reset specified keys to their initial values
      const newState = { ...state };
      if (!Array.isArray(action.payload)) return state;
      action.payload
        .filter((key): key is string => typeof key === 'string')
        .forEach((key) => {
          delete newState[key];
          // Also delete the loading and error variants
          delete newState[`${key}Loading`];
          delete newState[`${key}Error`];
        });
      return newState;
    }

    default:
      return state;
  }
};

export default commonReducer;
